<template>
   <div class="content-wrapper">
      <section class="content-header">
         <div class="row">
            <div class="col-xs-12">
               <h1 class="pull-left">
                  <span style="color:#00a65a">{{com_TVOwnerName()}}</span> Online Subscription Reports
               </h1>
               <div class="pull-right">
                  <a href="#" @click="downloadNow" class="btn" style="background-color: #526883; color: white;"><i class="fa fa-download"></i> Download Filtered</a>
                  &nbsp;
                  <a href="#" class="btn" style="background-color: #526883; color: white; display: none;"><i class="fa fa-cloud-download" style="font-size: 16px;"></i> Download All</a>
               </div>
            </div>
         </div>
      </section>
      <section class="content">
         <form v-on:submit.prevent="searchReportData">
         <div class="row">
            <div class="col-xs-6 col-sm-2">
               <div class="form-group">
                  <filterDropdownOptions />
               </div>
            </div>
            <div class="col-xs-6 col-sm-2 form-group">
               <input placeholder="From" type="text" value="" name="starttime" id="starttime" v-model="starttime" autocomplete="off" class="form-control input-sm datePicker">
            </div>
            <div class="col-xs-6 col-sm-2 form-group">
               <input placeholder="To" type="text" value="" name="stoptime" id="stoptime" v-model="stoptime" class="form-control input-sm datePicker" autocomplete="off">
            </div>
            <div class="col-xs-6 col-sm-2 form-group">
               <input placeholder="Search By Transaction ID" type="text" name="transaction_id" id="transaction_id" v-model="transaction_id" class="form-control input-sm" value="">
            </div>
            <div class="col-xs-6 col-sm-2 form-group">
               <input placeholder="Search By PIN" type="text" name="login" id="login" v-model="login" class="form-control input-sm" value="">
            </div>

            <div id="btnSearch" class="col-xs-6 col-sm-2 pull-right form-group  btnLeft" style="margin-bottom: 5px">
               <button type="submit" class="btn btn-sm btn-submit pull-right">
                  <i class="fa fa-search"></i> Search
               </button>
            </div>
         </div>
         </form>
         <div class="row">
            <div class="col-md-12">
               <div class="box" id="pagination">
                  <div class="box-header">
                     <h3 class="box-title">
                        Total {{listArr.length}} Row Found
                     </h3>
                  </div>
                  <div class="box-body">
                     <div class="table-responsive">
                        <table class="table table-0024 table-bordered table-striped">
                           <thead>
                              <tr>
                                 <th class="tdCenter tdSN">SN</th>
                                 <th class="tdCenter">TV PIN</th>
                                 <th class="tdCenter">Transaction ID</th>
                                 <th class="tdCenter">Plan</th>
                                 <th class="tdCenter" width="150">Payment Gateway</th>
                                 <th class="tdCenter">Date</th>
                                 <th class="tdCenter">Amount</th>
                              </tr>
                           </thead>
                           <tbody>
                              <tr v-for="(data, index) in listArr" :key="data.id">
                                 <td :class="'tdCenter tdSN'">
                                    {{parseInt(++index)}}
                                 </td>
                                 <td class="tdCenter success">
                                    {{com_removeTVPinPrefix(data.username, userData.reseller4.tv_pin_prefix)}}
                                 </td>
                                 <td class="tdCenter  ">
                                    {{data.transaction_id}}
                                 </td>
                                 <td class="tdCenter">
                                    {{data.plan_name}}
                                 </td>
                                 <td class="tdCenter bg-blue-gradient">
                                    {{data.payment_method}}
                                 </td>
                                 <td class="tdCenter">
                                    {{data.created_at}}
                                 </td>
                                 <td class="tdCenter">
                                    {{data.amount}}
                                 </td>
                             </tr>
                              <tr v-if="listArr.length==0">
                                 <td colspan="10" class="tdCenter" style="padding: 30px 0;"><b>No Records  Found</b></td>
                              </tr>
                           </tbody>
                        </table>
                     </div>
                  </div>

                  <div class="table-responsive">
                     <table class="table table-middle-small table-bordered">
                        <thead>
                           <tr>
                              <th class="tdCenter">Total Records</th>
                              <th class="tdCenter">Total Amount</th>
                           </tr>
                        </thead>
                        <tbody>
                           <tr>
                              <td class="success">{{listArr.length}}</td>
                              <td class="info">
                                 {{lineTotalAmount}}
                              </td>
                           </tr>
                        </tbody>
                     </table>
                  </div>

               </div>
            </div>
         </div>
      </section>
   </div>
</template>
<script>
   import filterDropdownOptions from "@/components/common/filterDropdownOptions.vue";
   import axios from 'axios'
   export default {
      name: "FlexOnlineSubscriptionReport",
      components: {
         filterDropdownOptions,
      },
      data() {
         return {
            listArr : [],
            userData : {},
            lineTotalAmount : 0,
            starttime : '',
            stoptime : '',
            login : '',
            transaction_id : '',
            userlevel:'',
            flexApiUrl : process.env.VUE_APP_APIFLEXURL,
            styleObject: {
               background:'#ffa196 !important',
            }
         }
      },
      created(){
         if(!this.com_isTVReseller(true, [393])){
            this.$router.push('dashboard');
         }

         //Get User Level from user store
         var encryptedData = this.$store.getters.getUser;
         var decodedString  = this.com_DecryptString(encryptedData);
         var userData = JSON.parse(decodedString);
         this.userData = userData;
         this.userlevel = userData.user_level;
         // End

         this.filterWiseDateRangeSet();
         this.searchReportData();
      },
      methods: {

         downloadNow(){
            loader.show();
            var rootObject = this;
   
            const form = new FormData()
            form.append('fromDate', this.starttime)
            form.append('toDate', this.stoptime)
            form.append('login', this.login)
            form.append('transaction_id', this.transaction_id)
            form.append('download', 1)
            form.append('short_filter', $("#short_filter").val());
            form.append('idReseller', this.userData.id_reseller)
            form.append('level', this.userData.user_level)
   
            var config = {
               headers: { 'Content-Type': 'multipart/form-data' },
               responseType: 'blob',
            }
   
            axios.post(rootObject.flexApiUrl+'/reports/online-subscription-report', form, config).then(function (response) {
               //console.log(response);
               const blob = new Blob([response.data], { type: 'application/csv' });
               var a = document.createElement('a');
               var url = window.URL.createObjectURL(blob);
               a.href = url;
               var prefix = 'online_subscription_report_'
               var file_name = prefix.concat(rootObject.getFormattedTime());
               var ext = '.csv';
               a.download = file_name.concat(ext);
               document.body.append(a);
               a.click();
               a.remove();
               window.URL.revokeObjectURL(url);
               loader.hide();
               
            })
            .catch(function (error) {
                let alertmessage = "";
                for (var prop in error.response.data) {
                  alertmessage += ' '+error.response.data[prop]
                }
                console.log(alertmessage);
                loader.hide();
                rootObject.com_errorHandel(error);
            });
         },


         searchReportData(){
            loader.show();
            var rootObject = this;
   
            const form = new FormData()
            form.append('fromDate', this.starttime)
            form.append('toDate', this.stoptime)
            form.append('login', this.login)
            form.append('transaction_id', this.transaction_id)
            form.append('short_filter', $("#short_filter").val());
            form.append('idReseller', this.userData.id_reseller)
            form.append('level', this.userData.user_level)
            
            var config = {
             headers: { 'Content-Type': 'multipart/form-data' }
            }
   
            axios.post(rootObject.flexApiUrl+'/reports/online-subscription-report', form, config).then(function (response) {
               //console.log(response);
               rootObject.populateReportData(response);
            })
            .catch(function (error) {
                let alertmessage = "";
                for (var prop in error.response.data) {
                  alertmessage += ' '+error.response.data[prop]
                }
                console.log(alertmessage);
                loader.hide();
                rootObject.com_errorHandel(error);
            });
         },
   
         populateReportData(response){
            var rootObject = this;
            var lineTotalAmount = 0;
            this.lineTotalAmount = 0;
            this.listArr = [];

            for (var prop in response.data.data) { 
               lineTotalAmount += parseFloat(response.data.data[prop]['amount']);   
            }

            this.listArr = response.data.data;
            this.lineTotalAmount = lineTotalAmount.toFixed(2);
            loader.hide();
         },
   
         filterWiseDateRangeSet()
         {
            $(".datePicker").removeAttr('readonly', 'readonly'); 
            if ($("#short_filter").val()) {
               this.starttime = '';
               this.stoptime = '';
               $(".datePicker").attr('readonly', 'readonly'); 
            }else{
               var dateRangeArr = this.com_currentDateRange();
               this.starttime = dateRangeArr.startDate;
               this.stoptime = dateRangeArr.endDate;
            }
         },

         getFormattedTime() {
            var today = new Date();
            var y = today.getFullYear();
            var m = today.getMonth() + 1;
            var d = today.getDate();
            return y + "-" + m + "-" + d;
         },
         
      },
      mounted: function() {
         var rootObject = this;
         $('#starttime').datetimepicker({
            timepicker: false,
            format: 'Y-m-d'
         }).on('change', function(e){
            rootObject.starttime = $(this).val();
         });

         $('#stoptime').datetimepicker({
            timepicker: false,
            format: 'Y-m-d'
         }).on('change', function(e){
            rootObject.stoptime = $(this).val();
         });

         $("#short_filter").on('change', function(){
            rootObject.filterWiseDateRangeSet();
            rootObject.searchReportData();
         });
   
         $(".select2").select2();
      }
   };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>